import axios from 'axios'

export async function useAvailableWorkflowActionCheck(path) {
    // return redirect to next available action if requested workflowaction is not available
    const pathSplit = path.split("/");
    const actionId = pathSplit.pop();
    let isAvailableAction = false; 

    let projectId;
    for (let i = 0; i < pathSplit.length; i++) {
        // first int in path is projectId
        if (!isNaN(pathSplit[i]) && !isNaN(parseInt(pathSplit[i]))) {
            projectId = pathSplit[i];
            break;
        }
    }

    const response = await axios.get(`/rest/v4/projects/${projectId}/availableactions`);
    const availableActions = response.data.data;
    if (availableActions !== undefined) {
        for (let availableAction of availableActions) {
            if (availableAction.id === actionId) {
                isAvailableAction = true;
                break;
            }
        }
    }

    if (!isAvailableAction) {
        if (availableActions === undefined && availableActions.length === 0) {
            // just redirect to project if there are no available actions
            return path.split('workflow - action')[0]
        }

        // redirect to first available action
        return `${pathSplit.join('/')}/${availableActions[0].id}`
    }

    return;
}